import { isCoverOnCreateFlowEnabled } from '../features'
import { convertDateToPaass } from '../localization/formatDateToPaass'
import serverData from '../server-data'

interface CreatePayload {
  title?: string
  description?: string
  closeDate?: string
  goalAmount?: string
  backgroundImageUrl?: string
}

export const createGroupPayload = (groupForm: CreatePayload) => {
  return {
    name: groupForm.title,
    description: groupForm.description,
    ...(groupForm.goalAmount && {
      targetAmount: {
        currencyCode: serverData.user.primaryCurrencyCode,
        value: groupForm.goalAmount,
      },
    }),
    targetDate: convertDateToPaass(groupForm.closeDate),
    ...(isCoverOnCreateFlowEnabled() && {
      backgroundImageUrl: groupForm.backgroundImageUrl,
    }),
  }
}
